import _regeneratorRuntime from 'babel-runtime/regenerator';
var _this = this;
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
import { connect } from 'react-redux';
import ResetPasswordFormComponent from './ResetPasswordFormComponent';
import { fetchResetPassword, setResetPasswordError, clearResetPasswordError } from '../../redux/actions/resetPasswordActions';
import { getQueryParam } from '../../helpers/queryParamsHelper';
import { reduxForm, formValueSelector, clearFields } from 'redux-form';
import { validatePassword, matchingPassword } from '../../helpers/formValidations';
var d1 = getQueryParam('d1');
var userid = getQueryParam('UserId');
var verifycode = getQueryParam('verifycode');
var ResetPasswordForm = reduxForm({
  form: 'resetPassword',
  asyncValidate: function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(values, dispatch, fieldProps, blurredField) {
      var invalid;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(blurredField === 'matchingPassword')) {
                _context.next = 5;
                break;
              }
              invalid = matchingPassword(values.matchingPassword, values);
              if (!invalid) {
                _context.next = 4;
                break;
              }
              throw {
                matchingPassword: invalid
              };
            case 4:
              return _context.abrupt('return', undefined);
            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));
    function asyncValidate(_x, _x2, _x3, _x4) {
      return _ref.apply(this, arguments);
    }
    return asyncValidate;
  }(),
  asyncBlurFields: ['matchingPassword'],
  onSubmit: function onSubmit(payload, dispatch) {
    var errorMessage = validatePassword(payload.password);
    if (errorMessage) {
      dispatch(clearFields('resetPassword', false, true, 'password', 'matchingPassword'));
      dispatch(setResetPasswordError({
        errorMessage: errorMessage
      }));
    } else {
      dispatch(fetchResetPassword({
        verifycode: verifycode,
        userid: userid,
        d1: d1,
        formValues: payload
      }));
    }
  }
})(ResetPasswordFormComponent);
var selector = formValueSelector('resetPassword');
var mapStateToProps = function mapStateToProps(state) {
  var processingResetPassword = state.apiProcessing.processingResetPassword,
    _state$resetPassword = state.resetPassword,
    message = _state$resetPassword.message,
    fetchError = _state$resetPassword.error,
    validateError = _state$resetPassword.validateError;
  return {
    passwordValue: selector(state, 'password'),
    processingResetPassword: processingResetPassword,
    message: message,
    fetchError: fetchError,
    validateError: validateError
  };
};
var mapDispatchToProps = {
  clearResetPasswordError: clearResetPasswordError
};
export default connect(mapStateToProps, mapDispatchToProps)(ResetPasswordForm);